import {
    getConfig,
    Locale,
} from '@superbet-group/web.lib.config';
import {
    Country,
    SuperAdvantageEligibility,
} from '@superbet-group/web.types';

import Tournament from '@models/struct/Tournament';

import { TournamentDto } from './dtos/TournamentDto';
import { shellLocalConfig } from '@src/config/shell/localConfig';

export function mapTournaments(tournamentDtos: TournamentDto[]): Tournament[] {
    return tournamentDtos.map((tournamentDto) => {
        const locale = getConfig().countrySpecific.country === Country.Com ? Locale.EnglishBelgian : getConfig().appLocale.locale;
        return {
            id: parseInt(tournamentDto.id, 10),
            name: tournamentDto.localNames[locale]!,
            urlName: tournamentDto.localNames[shellLocalConfig.urlLocale]!,
            order: tournamentDto.order,
            orderPromoted: tournamentDto.orderPromoted,
            footer: tournamentDto.footer,
            superAdvantage: tournamentDto.superAdvantage as SuperAdvantageEligibility | undefined,
        };
    });
}
